import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import ServicesMain          from './services-main.component';
import Compute from '../compute/compute.component';
import NotFound from '../../../common/not-found/not-found.component';
import { AuthGuard } from '../../auth/auth.guard';

import DisasterRecoveryEmbed from '../disaster-recovery/disaster-recovery-embed';
import AddEditNetworkDialog from '../../modules/networking/networking-vc/networks/dialogs/add-edit-network-dialog.component';
import AddEditImportNetworkDialog from '../../modules/networking/networking-vc/networks/import-network/add-edit-import-network-dialog.component';
import AddEditGatewayWizard from '../../modules/networking/networking-vc/gateways/dialogs/add-edit-gateway-wizard.component';
import { GatewayListing } from '../../modules/networking/networking-vc/gateways/listing/gateway-listing.component';
import { NetworkListing } from '../../modules/networking/networking-vc/networks/listing/network-listing.component';

import NetworkingView from '../../modules/networking/networking-vc/networking-view.component';
import NetworkingVcdView from '../../modules/networking/networking-vcd/networking-vcd.components';
import MigrationEmbed from '../migration/migration-embed';
import NetworkExtensionEmbed from '../network-extension/network-extension-embed';
import NetworkExtensionEmbed2 from '../network-extension2/network-extension-embed2';
import { ImportGatewayDialog } from '../../modules//networking/networking-vc/gateways/dialogs/import-gateway/import-gateway-dialog.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            { path: 'services', component: ServicesMain, canActivate: [AuthGuard],
                children: [
                    { path: '', redirectTo: 'compute', pathMatch: 'full'},
                    { path: 'compute', component: Compute,
                        canActivate: [AuthGuard]},
                 /*   { path: 'upgradeapp', component: PublisherApp,
                        canActivate: [AuthGuard]},*/
                    { path: 'networks', component: NetworkingVcdView,
                        canActivate: [AuthGuard]},
                    { path: 'networking', component: NetworkingView , canActivate: [AuthGuard],
                      children: [
                            {path: '', component: NetworkingView, canActivate: [AuthGuard]},
                            {path: 'network', component:  NetworkListing, canActivate: [AuthGuard],
                            children: [
                                {path: 'new', component: AddEditNetworkDialog,
                                canActivate: [AuthGuard]},
                                {path: 'edit/:id', component: AddEditNetworkDialog,
                                canActivate: [AuthGuard]},
                                {path: 'import', component: AddEditImportNetworkDialog,
                                canActivate: [AuthGuard]},
                                {path: 'edit-import/:id', component: AddEditImportNetworkDialog,
                                canActivate: [AuthGuard]}
                            ]},
                            {path: 'gateways', component: GatewayListing,
                            canActivate: [AuthGuard],
                            children: [
                                {path: 'new', component: AddEditGatewayWizard,
                                canActivate: [AuthGuard]},
                                 {path: 'edit/:id', component: AddEditGatewayWizard,
                                canActivate: [AuthGuard]},
                                {path: 'import', component: ImportGatewayDialog,
                                canActivate: [AuthGuard]}
                            ]}
                      ]
                    },
                    { path: 'network-extension-embed', component: NetworkExtensionEmbed, canActivate: [AuthGuard]},
                    { path: 'network-extension-embed2', component: NetworkExtensionEmbed2, canActivate: [AuthGuard]},
                    { path: 'migration-embed', component: MigrationEmbed, canActivate: [AuthGuard]},
                    { path: 'disaster-recovery-embed', component: DisasterRecoveryEmbed,
                        canActivate: [AuthGuard]},
                    { path : '**', component: NotFound }
                ]}
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class ServicesRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/components/services-main/services-routing.module.ts